import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

interface FieldProps {
  span?: number
}

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.xm};

  .form {
    padding: 10px;
    margin-bottom: 5px;
  }
`

export const Title = styled.h5`
  color: ${theme.colors.neutral.black};
  font-size: ${theme.typography.sizes['2md']};
  font-family: ${theme.typography.family.primary};
  font-weight: ${theme.typography.weight.xl};

  margin: 0px;
  padding-left: 5px;
`

export const Form = styled.form`
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  gap: ${theme.spacing.md};
`

export const Field = styled.div<FieldProps>`
  display: flex;
  flex-direction: column;
  grid-column: span ${({ span }) => span || 2};
`

export const CubageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.xs};
`

export const VersionCheckWrapper = styled.div`
  display: flex;
  height: 40px;
  align-self: flex-end;
  align-items: flex-end;

  span {
    font-weight: ${theme.typography.weight.lg} !important;
  }
`

export const InsertionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.xm};
`

export const ColWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${theme.colors.neutral.clear};
`

export const ErrorWrapper = styled(ColWrapper)`
  gap: ${theme.spacing.md};
`

export const UploadedFileViewer = styled.div`
  display: flex;
  align-items: center;
  height: 62px;
  width: 100%;
  padding: 16px;
  gap: ${theme.spacing.xs};
  border: ${theme.shapes.borderWidth.thin} ${theme.colors.neutral.mediumhover};
  border-radius: ${theme.shapes.borderRadius.sm};
  p {
    color: ${theme.colors.neutral.high} !important;
  }
`

export const DeleteOrdersActions = styled.div`
  display: flex;
  width: 100%;
  gap: ${theme.spacing.xs};
  justify-content: flex-end;
`
